import e from"react";import t from"../../../external/classnames/index.js";const r=({children:r,className:s=""})=>{const n=t("list-component",s);return e.createElement("ul",{className:n},r)};export{r as List};
//# sourceMappingURL=List.js.map
